import {
  CLIENT_TOTAL_EXPIRED_MEMBERSHIPS,
  CLIENT_TOTAL_EXPIRED_MEMBERSHIPS_SUCCESS,
  CLIENT_TOTAL_EXPIRED_MEMBERSHIPS_ERROR,
  CLIENT_TOTAL_EXPIRED_MEMBERSHIPS_EMPTY,
} from '../../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientTotalExpiredMemberships = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_TOTAL_EXPIRED_MEMBERSHIPS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_TOTAL_EXPIRED_MEMBERSHIPS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLIENT_TOTAL_EXPIRED_MEMBERSHIPS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_TOTAL_EXPIRED_MEMBERSHIPS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientTotalExpiredMemberships;
